import { combineReducers } from 'redux';
import { segmentCategory } from './segment-category/segmentCategory.reducer';
import { segmentPricing } from './segment-pricing/segmentPricing.reducer';

export const dataProvider = combineReducers({ segmentCategory, segmentPricing });